export default {
  backoffice: {
    // title — имя раздела управления: его печатает и сам бекофис, и
    // route.meta.title (шапка, крошки, вкладка браузера).
    title: 'Управление',
    sections: {
      backoffice: 'Управление',
      discover: 'Каталог',
      management: 'Справочники',
      sales: 'Заказы и продажи',
      general: 'Общее',
    },
    nav: {
      dashboard: 'Обзор',
      organizations: 'Организации',
      users: 'Пользователи',
      notifications: 'Уведомления',
      products: 'Товары',
      events: 'События',
      community: 'Сообщество',
      spots: 'Точки',
      gallery: 'Галерея',
      categories: 'Категории',
      inventory: 'Склад',
      rents: 'Аренда',
      orders: 'Заказы',
      customers: 'Клиенты',
      applications: 'Заявки',
      promotions: 'Промо',
      payments: 'Платежи',
      pages: 'Страницы',
      reports: 'Отчёты',
    },
  },
};
